(function () {
    angular
        .module('advancedapp')
        .directive('emitLastRepeaterElement', emitLastRepeaterElement);

    emitLastRepeaterElement.$inject = ['$window', '$timeout'];

    function emitLastRepeaterElement($window, $timeout) {

        var directive = {
            link: link,
            restrict: 'EA',
           
        };
        return directive;

        function link(scope, element, attrs) {

            if (scope.$last) {

                $(document).foundation();
            }
           
        }
    }

})();